module.exports = __webpack_public_path__ + "img/wifi.34813448.png";